export default "__VITE_ASSET__CSJk6MZp__"